import { FbqEventOptions, trackFbqEvent } from "./fbqEventFactory";

export const trackFbqPageView = (options?: FbqEventOptions): void =>
  trackFbqEvent("PageView", options);
